import React, {FunctionComponent} from 'react';
import "./topbar.scss";
import Content from "../Content/Content";
import magnumLogo from "../../assets/magnumbet_logo.png";
import Button from "../Button/Button";
import Anchor from "../Anchor";
import clsx from "clsx";

interface IProps {
    showMenu?: boolean;
}

const TopBar:FunctionComponent<IProps> = ({showMenu = true}) => {

    const isMobile = window.innerWidth <= 768;


    return (
        <div className={`top-bar-container ${!showMenu ? "disableMenu" : ""}`}>
            <Content className="top-bar-wrapper">
                <img className={clsx("top-bar-logo", {["lowerLogo"]: !showMenu})} src={magnumLogo} alt="magnum logo"/>


                {showMenu &&
                    <div className="controls-container">
                        <span>Ai deja un cont? <Anchor href="https://magnumbet.ro/ro/login">Conectare</Anchor> { isMobile && <span> | <Anchor classes="magnum-gold" href="https://magnumbet.ro/casino/registration">Înregistrare</Anchor></span> }</span>
                        {!isMobile && <Button href={"https://magnumbet.ro/casino/registration"} variation={1}>
                            înregistrare
                        </Button>}
                    </div>
                }

            </Content>
        </div>
    );
}

export default TopBar;